import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function CircularProgress({ size = 40, color = colors.primary, style, className, }) {
    return (jsx(Box, { "$size": size, "$color": color, style: style, className: className, children: jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: jsx("circle", { r: "11", cy: "12", cx: "12", stroke: "currentColor", strokeWidth: "1", strokeLinecap: "round", fill: "transparent", strokeDasharray: "20 70" }) }) }));
}
const Box = styled.span `
  display: inline-block;
  color: ${({ $color }) => $color};
  width: ${({ $size }) => (typeof $size === "number" ? `${$size}px` : $size)};
  height: ${({ $size }) => (typeof $size === "number" ? `${$size}px` : $size)};
  animation: spin 1s ease infinite;

  svg {
    display: block;
    transform: rotate(-140deg);
    transform-origin: center;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export { CircularProgress };
